import type { FormFieldControlViewProps } from "./types-control";

/** Sem elemento próprio: as props da tela vão no filho, que recebe as do campo por cima. */
export function FormFieldControlView({ element }: FormFieldControlViewProps) {
  return element;
}
